import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { Toggle } from '@motorway/mw-highway-code/alpha';

import type { ViewingFilterValue } from 'Utilities/seenVehicles/seenVehicles';
import { VIEWING_FILTER } from 'Utilities/seenVehicles/seenVehicles';

import allTexts from '../../../VehicleListV2.texts.json';

import styles from './AllFiltersContent.module.scss';

const LocalT = new MDText(allTexts);

interface ToggleSectionProps {
	onChange: () => void;
	value: ViewingFilterValue;
}

export const ToggleSection: FC<ToggleSectionProps> = ({ onChange, value }) => (
	<div className={styles.toggleWrapper}>
		<Toggle
			showLabel
			formProps={{
				input: {
					checked: value === VIEWING_FILTER.NEW,
					name: 'seen-filter-toggle',
					onChange,
					type: 'checkbox',
				},
			}}
			id="all-filters-seen-toggle"
			label={`${LocalT.translate('allFiltersModal.toggleHideViewed')}`}
		/>
	</div>
);
